import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { map} from 'rxjs/operators';
import { DataSourceService } from './data-source.service';
import { FILE_EXTENSION_TYPE, FILE_BLOB_TYPE } from 'src/app/app.constants';
import { WindchillAccessResponse } from '../shared/models/news-updates.model';
import * as FileSaver from 'file-saver'

@Injectable({
  providedIn: 'root'
})
export class NewsUpdateDetailsService {

  constructor(private dataSource: DataSourceService) { }
  getActiveProjectLink(cwsId: string): Observable<WindchillAccessResponse> {
    return this.dataSource.getActiveProjectLink(cwsId);
  }

  getDownloadStaticFile(documentslink: string): Observable<Blob>  {
    return this.dataSource.getDownloadStaticFile(documentslink);
  }
}
